<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      class="purchaseReceivingEdit"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : pkid > 0 ? '编辑' : '新建 '"
      width="1200px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        class="form"
        :disabled="disabled"
        :model="filter"
        :rules="ruleValidate"
        label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="预计到货日期">
            <el-date-picker
                v-model="filter.plannedArrivalTime"
                type="datetime"
                :disabled="isChecked"
                placeholder="请选择日期"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-button v-if="!disabled" type="primary" style="margin-bottom: 10px" @click="$refs.purchaseOrderSelect.open(20)"> 新增 </el-button>
      <el-table class="tableBox" :data="filter.receiveDetails" border height="500px">
        <el-table-column 
            prop="purchaseOrderNo"
            align="center"
            label="采购订单"
            width="150"
            show-overflow-tooltip/>
        <el-table-column prop="poDetailRowNO" align="center" label="采购单行项" width="90"/>
        <el-table-column 
            prop="materialNO"
            align="center"
            label="物料编号"
            width="120"
            show-overflow-tooltip/>
        <el-table-column 
            prop="materialName" 
            align="left" 
            label="物料描述" 
            min-width="120" 
            show-overflow-tooltip/>
        <el-table-column prop="specification" align="center" label="规格型号" min-width="160"/>
        <el-table-column prop="rowIndex" align="center" label="送货单行项" width="90"/>
        <el-table-column prop="sumQuantity" align="center" label="数量" width="70"/>
        <el-table-column prop="quantity" align="center" label="本次送货数量" width="150">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.quantity" :disabled="isChecked" placeholder="请输入" @change="checkQuantity(scope.row)"/>
          </template>
        </el-table-column>
        <template v-if="disabled || isChecked">
          <el-table-column prop="qualifiedQuantity" align="center" label="合格数量" width="90">
            <template slot-scope="scope">
              <el-input v-if="isChecked" v-model="scope.row.qualifiedQuantity" placeholder="请输入"/>
              <span v-if="!isChecked">{{scope.row.qualifiedQuantity}}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="unitName" align="center" label="单位" width="70"/>
        <el-table-column prop="note" align="center" label="备注" width="200">
          <template slot-scope="scope">
            <el-input 
                v-model="scope.row.note" 
                :disabled="isChecked"
                autosize
                type="textarea" 
                width="200"/>
          </template>
        </el-table-column>
        <el-table-column v-if="!disabled" label="操作" align="center" prop="action">
          <template slot-scope="scope">
            <el-button type="danger" :disabled="isChecked" @click="deleteRow(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <purchase-order-select ref="purchaseOrderSelect" @select="purchaseOrderSelect"/>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button 
          v-if="!disabled"
          :disabled="AmountCorrect"
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit"> 
        确定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  import PurchaseOrderSelect from "../PurchaseOrder/PurchaseOrderSelect";
  export default {
    name: "PurchaseReceivingEdit",
    components: { PurchaseOrderSelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        pkid: "",
        disabled: false,
        flag: false,
        AmountCorrect: false,
        isChecked: false,
        filter: {
          plannedArrivalTime: "",
          supplierId: "",
          receiveDetails: [],
        },
        ruleValidate: {},
      };
    },
    methods: {
      //页面开启
      open(row, disabled) {
        this.dialogVisible = true;
        if (row) {
          this.pkid = row.mastPKID;
          this.getData();
        }
        if (disabled === "check") {
          this.isChecked = true;
        } else if (disabled) {
          this.disabled = true;
        }
      },

      //编辑时获取已有数据
      getData() {
        this.$http.get("basic", `purchaseReceives/${this.pkid}`).then((res) => {
          console.log(res);
          if (res.success) {
            this.filter = res.data;
          }
        });
      },
      purchaseOrderSelect(purchaseOrderList) {
        let index= 0;
        purchaseOrderList.forEach(item=>{
          index = index + 1;
          this.purchaseOrderAdd(item,index);
        });
      },
      purchaseOrderAdd(row,index) {
        const WrongEvaluate = this.filter.receiveDetails.find(
          (item) => item.purchaseOrderNo === row.purchaseOrderNo && item.poDetailRowNO === row.rowIndex
        );
        const WrongSupplier = this.filter.receiveDetails.find((item) => item.supplierNo !== row.supplierNo);
        if (WrongEvaluate || WrongSupplier) {
          if (WrongEvaluate) {
            this.$message.error("采购单"+ row.purchaseOrderNo +"已存在，请勿重复添加");
          }
          if (WrongSupplier) {
            this.$message.error("采购单"+ row.purchaseOrderNo +"供应商不一致，请重新选择");
          }
        } else {
          const obj = {
            purchaseOrderNo: row.purchaseOrderNo,
            poDetailRowNO: row.rowIndex,
            rowIndex: index,
            materialId: row.materialId,
            materialNO: row.materialNo,
            materialName: row.materialName,
            sumQuantity: row.qty,
            quantity: row.qty - (row.sendedQuantity ? row.sendedQuantity : 0),
            sendedQuantity: row.sendedQuantity,
            supplierNo: row.supplierNo,
            supplierName: row.supplierName,
            purchaseOrderId: row.mastPKID,
            note: row.remark,
          };
          this.filter.supplierId = row.supplierId;
          this.filter.receiveDetails.push(obj);
        }
      },
      // 检测本次送货数量是否超出剩余发货数量
      checkQuantity(row) {
        if (!this.isChecked) {
          const reg = /^[0-9]*.\d{0,2}$/;
          if (!reg.test(row.quantity) || row.quantity <= 0) {
            this.$confirm("请输入正确的送货数量", "错误", {
              type: "error",
              showCancelButton: false,
            });
            row.quantity = "";
          }
        }
      },
      deleteRow(index) {
        this.filter.receiveDetails.splice(index, 1);
      },
      //提交表单数据
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            if (this.pkid) {
              this.$http
                .post("basic", "purchaseReceives/update", this.filter)
                .then((res) => {
                  if (res.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  } else {
                    this.submitLoading = false;
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .save("basic", "purchaseReceives/create", this.filter)
                .then((res) => {
                  if (res.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  } else {
                    this.submitLoading = false;
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          } else {
            this.submitLoading = false;
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
